import { render, staticRenderFns } from "./HomeProject.vue?vue&type=template&id=073a4f44&scoped=true"
import script from "./HomeProject.vue?vue&type=script&lang=js"
export * from "./HomeProject.vue?vue&type=script&lang=js"
import style0 from "./HomeProject.css?vue&type=style&index=0&id=073a4f44&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073a4f44",
  null
  
)

export default component.exports